var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarCardBenefitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5914_39326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6673 14.5898V13.2565C24.6673 13.0797 24.5971 12.9101 24.4721 12.7851C24.347 12.6601 24.1775 12.5898 24.0007 12.5898C23.8238 12.5898 23.6543 12.6601 23.5292 12.7851C23.4042 12.9101 23.334 13.0797 23.334 13.2565V14.5898H24.6673Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 14.5898V13.2565C16.6673 13.0797 16.5971 12.9101 16.4721 12.7851C16.347 12.6601 16.1775 12.5898 16.0007 12.5898C15.8238 12.5898 15.6543 12.6601 15.5292 12.7851C15.4042 12.9101 15.334 13.0797 15.334 13.2565V14.5898H16.6673Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.9235H14C13.4696 27.9235 12.9609 27.7128 12.5858 27.3377C12.2107 26.9626 12 26.4539 12 25.9235V17.2568C12 16.7264 12.2107 16.2177 12.5858 15.8426C12.9609 15.4675 13.4696 15.2568 14 15.2568H26C26.5304 15.2568 27.0391 15.4675 27.4142 15.8426C27.7893 16.2177 28 16.7264 28 17.2568V25.9235C28 26.4539 27.7893 26.9626 27.4142 27.3377C27.0391 27.7128 26.5304 27.9235 26 27.9235ZM26.6667 18.5902H13.3333V25.9235C13.3333 26.1003 13.4036 26.2699 13.5286 26.3949C13.6536 26.5199 13.8232 26.5902 14 26.5902H26C26.1768 26.5902 26.3464 26.5199 26.4714 26.3949C26.5964 26.2699 26.6667 26.1003 26.6667 25.9235V18.5902Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 19.9229H14.666V21.9229H17.3327V19.9229Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 19.9229H18.666V21.9229H21.3327V19.9229Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 23.2568H14.666V25.2568H17.3327V23.2568Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 23.2568H18.666V25.2568H21.3327V23.2568Z",
    fill: "#9C82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3327 19.9229H22.666V21.9229H25.3327V19.9229Z",
    fill: "#9C82FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5914_39326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5898)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCardBenefitIcon);
export default __webpack_public_path__ + "static/media/calendar-card-benefit-icon.3164effe2d0d969959011f00c31d93c8.svg";
export { ForwardRef as ReactComponent };